export enum LabelType {
  Default = "default",
  Warranty = "waranty",
  SecondHand = "second_hand",
  Promotion = "promotion",
}
